// extracted by mini-css-extract-plugin
export var statItem = "_kh-1";
export var statsRow = "_kh-0";